"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _4_multisignature_transaction_1 = require("./4_multisignature_transaction");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var validateInputs = function validateInputs(_ref) {
  var keysgroup = _ref.keysgroup,
      lifetime = _ref.lifetime,
      minimum = _ref.minimum;

  if (!utils_1.isValidInteger(lifetime) || lifetime < constants_1.MULTISIGNATURE_MIN_LIFETIME || lifetime > constants_1.MULTISIGNATURE_MAX_LIFETIME) {
    throw new Error("Please provide a valid lifetime value. Expected integer between ".concat(constants_1.MULTISIGNATURE_MIN_LIFETIME, " and ").concat(constants_1.MULTISIGNATURE_MAX_LIFETIME, "."));
  }

  if (!utils_1.isValidInteger(minimum) || minimum < constants_1.MULTISIGNATURE_MIN_KEYSGROUP || minimum > constants_1.MULTISIGNATURE_MAX_KEYSGROUP) {
    throw new Error("Please provide a valid minimum value. Expected integer between ".concat(constants_1.MULTISIGNATURE_MIN_KEYSGROUP, " and ").concat(constants_1.MULTISIGNATURE_MAX_KEYSGROUP, "."));
  }

  if (keysgroup.length < minimum) {
    throw new Error('Minimum number of signatures is larger than the number of keys in the keysgroup.');
  }

  utils_1.validateKeysgroup(keysgroup);
};

exports.registerMultisignature = function (inputs) {
  validateInputs(inputs);
  var keysgroup = inputs.keysgroup,
      lifetime = inputs.lifetime,
      minimum = inputs.minimum,
      passphrase = inputs.passphrase,
      secondPassphrase = inputs.secondPassphrase;
  var plusPrependedKeysgroup = utils_1.prependPlusToPublicKeys(keysgroup);
  var keygroupFees = plusPrependedKeysgroup.length + 1;
  var transaction = Object.assign({}, utils_1.createBaseTransaction(inputs), {
    type: 4,
    fee: (constants_1.MULTISIGNATURE_FEE * keygroupFees).toString(),
    asset: {
      multisignature: {
        min: minimum,
        lifetime: lifetime,
        keysgroup: plusPrependedKeysgroup
      }
    }
  });

  if (!passphrase) {
    return transaction;
  }

  var multisignatureTransaction = new _4_multisignature_transaction_1.MultisignatureTransaction(transaction);
  multisignatureTransaction.sign(passphrase, secondPassphrase);
  return multisignatureTransaction.toJSON();
};